var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"}),_c('asset-v3',{staticClass:"logo",attrs:{"dir":"icons","name":"parcelex-X.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }